// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { SubstitutionThresholdDetailsV2Fragment } from '../../../../../modules/entities/gratTrusts/SubstitutionThresholdSubform/graphql/SubstitutionThresholdSubform.generated';
import { gql } from '@apollo/client';
import { SubstitutionThresholdDetailsV2FragmentDoc } from '../../../../../modules/entities/gratTrusts/SubstitutionThresholdSubform/graphql/SubstitutionThresholdSubform.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SetEntityThresholdsMutationVariables = Types.Exact<{
  input: Types.AugmentedUpdateEntityInput;
  taskID: Types.Scalars['ID']['input'];
}>;


export type SetEntityThresholdsMutation = { __typename?: 'Mutation', updateEntity: (
    { __typename?: 'Entity' }
    & SubstitutionThresholdDetailsV2Fragment
  ), completeEntityTask: { __typename?: 'EntityTask', id: string } };

export const Operations = {
  Mutation: {
    SetEntityThresholds: 'SetEntityThresholds' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const SetEntityThresholdsDocument = gql`
    mutation SetEntityThresholds($input: AugmentedUpdateEntityInput!, $taskID: ID!) {
  updateEntity(input: $input) {
    ...SubstitutionThresholdDetailsV2
  }
  completeEntityTask(id: $taskID) {
    id
  }
}
    ${SubstitutionThresholdDetailsV2FragmentDoc}`;
export type SetEntityThresholdsMutationFn = Apollo.MutationFunction<SetEntityThresholdsMutation, SetEntityThresholdsMutationVariables>;

/**
 * __useSetEntityThresholdsMutation__
 *
 * To run a mutation, you first call `useSetEntityThresholdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEntityThresholdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEntityThresholdsMutation, { data, loading, error }] = useSetEntityThresholdsMutation({
 *   variables: {
 *      input: // value for 'input'
 *      taskID: // value for 'taskID'
 *   },
 * });
 */
export function useSetEntityThresholdsMutation(baseOptions?: Apollo.MutationHookOptions<SetEntityThresholdsMutation, SetEntityThresholdsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetEntityThresholdsMutation, SetEntityThresholdsMutationVariables>(SetEntityThresholdsDocument, options);
      }
export type SetEntityThresholdsMutationHookResult = ReturnType<typeof useSetEntityThresholdsMutation>;
export type SetEntityThresholdsMutationResult = Apollo.MutationResult<SetEntityThresholdsMutation>;
export type SetEntityThresholdsMutationOptions = Apollo.BaseMutationOptions<SetEntityThresholdsMutation, SetEntityThresholdsMutationVariables>;